import { AxiosError, AxiosResponse } from "axios";
import api from "@services/axios/apiManager";

export interface CustomerDelivery {
  customer_delivery_id: number;
  customer_address_id: number;
  usage_location: string;
  note: string | null;
  floor: number;
  is_elevator: boolean;
  // 後端序列化（CustomerDeliveryResDto / bootstrap install_locations）不暴露 deleted，故設為選填
  deleted?: boolean;
}

interface GetCustomerDeliveryListParams {
  customerAddressId: number | string;
  jwtToken: string;
  xContext: string;
}

type GetCustomerDeliveryListResult =
  | { state: "success"; data: CustomerDelivery[] }
  | { state: "error"; error: AxiosError };

export const getCustomerDeliveryList = async ({
  customerAddressId,
  jwtToken,
  xContext,
}: GetCustomerDeliveryListParams): Promise<GetCustomerDeliveryListResult> => {
  const apiUrl = `/app-api/delivery/address/location/${customerAddressId}`;
  try {
    const res: AxiosResponse = await api.get(apiUrl, {
      headers: {
        Authorization: `Bearer ${jwtToken}`,
        "X-Context": xContext,
      },
    });
    const raw = res?.data?.data;
    const list = Array.isArray(raw) ? (raw as CustomerDelivery[]) : [];
    return { state: "success", data: list.filter((d) => !d.deleted) };
  } catch (error) {
    return { state: "error", error: error as AxiosError };
  }
};
